<template>
  <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
    <div
      style="
        width: 100%;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 20px;
      "
    >
      教室查询
    </div>
    <Sift
      ref="needSift"
      :sift-data="siftData"
      v-if="siftData.length"
      @change="initPage"
    >
      <el-col class="flex-box al-c" :span="4">
        <el-button type="primary" @click="initPage">查询</el-button>
        <el-button
          type="primary"
          :disabled="multipleSelection.length == 0"
          @click="downIds"
          >批量下载</el-button
        >
      </el-col>
    </Sift>

    <div class="table-con">
      <el-table
        class="w100 mt20 table"
        header-row-class-name="table-head"
        @selection-change="handleSelectionChange"
        row-class-name="cu-p"
        stripe
        :data="list"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column align="center" label="序号" width="50px">
          <template slot-scope="scope">
            {{
              paramSearch.current * paramSearch.size -
              paramSearch.size +
              scope.$index +
              1
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="buildTypeName"
          label="楼栋类型"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="buildName"
          label="楼栋名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="floorNumName"
          label="楼层号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="orgName"
          label="组织机构"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="roomName"
          label="教室名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="roomPurposeName"
          label="教室用途"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="roomTypeName"
          label="教室类型"
        ></el-table-column>
        <el-table-column align="center"  label="状态">
          <template slot-scope="{ row }">
            <span class="text">{{ row.status == 1 ? "可用" : "停用" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="refuseIP" label="操作">
          <template slot-scope="scope">
            <div class="to-use">
              <span class="text" @click="downId(scope.row)">下载二维码</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="">
          <template slot-scope="scope">
            <div class="to-use">
              <span class="text" @click="setJw(scope.row)">设置经纬度</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination
        background
        @size-change="changeSize"
        @current-change="changePage"
        :current-page.sync="paramSearch.current"
        :page-sizes="pageSizes"
        :page-size.sync="paramSearch.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!--设置经纬度-->
    <el-dialog
      title="设置经纬度"
      width="680px"
      append-to-body
      :visible.sync="modelShow"
      :destroy-on-close="true"
    >
      <div style="height: 300px">
        <el-form
          :inline="true"
          :rules="rules"
          label-width="100px"
          :model="form"
          ref="form"
          class="demo-form-inline"
        >
          <el-form-item label="经度" prop="longitude">
            <el-input
              style="width: 500px"
              v-model="form.longitude"
              placeholder="值在-180～180之间，必须输入1-20位小数,例如:116.27490509960936"
            ></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="latitude">
            <el-input
              style="width: 500px"
              v-model="form.latitude"
              placeholder="值在-90～180之间，必须输入1-20位小数,例如:39.9264008525172"
            ></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div style="color: #ccc; width: 500px; overflow: hidden">
              请使用百度地图拾取坐标系统获取经纬度,以免因算法不同造成误差过大:
              <a
                target="blank"
                href="http://api.map.baidu.com/lbsapi/getpoint/index.html"
                >http://api.map.baidu.com/lbsapi/getpoint/index.html</a
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modelShow = false">关闭窗口</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import {
  getClassRoomPage,
  getBuildList,
  getDicType,
} from "@/api/managementCenter/classroom";
import { setLangt } from "@/api/overseasChinese/overseasChinese";

export default {
  name: "classroomQuery",
  components: {
    Sift,
  },
  props: [],
  data() {
    return {
      loading: false,
      siftData: [
        {
          type: "text",
          key: "roomName",
          label: "教室名称",
          placeholder: "请输入教室名称",
          default: "",
        },
        {
          type: "select",
          key: "buildId",
          label: "楼栋名称",
          placeholder: "请选择楼栋名称",
          data: [],
          default: "",
        },
        {
          type: "select",
          key: "floorNum",
          label: "楼层号",
          placeholder: "请选择楼层号",
          data: [],
          default: "",
        },
        {
          type: "select",
          key: "roomPurpose",
          label: "教室用途",
          placeholder: "请选择楼教室用途",
          data: [],
          default: "",
        },
        {
          type: "select",
          key: "roomType",
          label: "教室类型",
          placeholder: "请选择教室类型",
          data: [],
          default: "",
        },
        {
          type: "select",
          key: "status",
          label: "状态",
          placeholder: "请选择状态",
          data: [
            {
                label:'可用',
                value:'1'
            },
            {
                label:'停用',
                value:'0'
            }
          ],
          default: "",
        },
      ],
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        name: "",
      },
      total: 0,
      multipleSelection: [],
      modelShow: false,
      form: {
        longitude: "",
        latitude: "",
      },
      rules: {
        longitude: [
          { required: true, message: "请填写经度", trigger: "blur" },
          {
            pattern:
              /^[\-\+]?(0?\d{1,2}\.\d{1,20}|1[0-7]?\d{1}\.\d{1,20}|180\.0{1,20})$/,
            message:
              "值在-180～180之间，必须输入1-20位小数,例如:116.27490509960936",
          },
        ],
        latitude: [
          { required: true, message: "请填写纬度", trigger: "blur" },
          {
            pattern: /^[\-\+]?([0-8]?\d{1}\.\d{1,20}|90\.0{1,20})$/,
            message:
              "值在-90～90之间，必须输入1-20位小数,例如:39.9264008525172",
          },
        ],
      },
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getListFn();
    this.getBuildList();
    this.dicType();
    this.getclassroomUse()
    this.getclassroomType()
  },
  methods: {
    setJw(row) {
      this.modelShow = true;
      this.form = {
        classRoomId: row.id,
        longitude: row.longitude,
        latitude: row.latitude,
      };
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          setLangt(this.form)
            .then((res) => {
              if (res.data.code == "0") {
                this.$message.success("设置成功!");
                this.modelShow = false;
                this.getListFn();
              } else {
                this.$message.warning(res.data.msg || "设置失败!");
              }
            })
            .catch(() => {
              this.$message.error("服务异常");
            });
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取楼栋名称
    async getBuildList() {
      const { data } = await getBuildList();
      if (data.code == 0) {
        if (data.data.length > 0) {
          this.siftData[1].data = data.data.map((elem) => {
            return {
              label: elem.buildName,
              value: elem.buildId,
            };
          });
        } else {
          this.siftData[1].data = [];
        }
      }
    },
    // 获取楼层号
    async dicType() {
      const { data } = await getDicType("floor_number");
      if (data.code == 0) {
          this.siftData[2].data = data.data
      }
    },
    // 获取教室用途
    async getclassroomUse() {
      const { data } = await getDicType("classroom_use");
      if (data.code == 0) {
          this.siftData[3].data = data.data;
      }
    },
    // 获取教室类型
    async getclassroomType() {
      const { data } = await getDicType("classroom_type");
      if (data.code == 0) {
          this.siftData[4].data = data.data
      }
    },
    // 获取查询列表
    getListFn() {
      this.loading = true;
      getClassRoomPage(this.paramSearch)
        .then(({ data }) => {
          this.loading = false;
          if (data.code == 0) {
            this.list = data.data.records || [];
            this.total = data.data.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 下载二维码
    downId(row) {
      let url = "/hq/classroom/roomQR?id=" + row.id;
      this.downloadFn(url);
    },
    downloadFn(url) {
      this.$DownLoad(
        url,
        (res) => {
          if (res.status == 200) {
          } else {
            this.$alert("下载出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning",
            });
          }
        }
        // error => {
        //     this.$alert(error, "提示", {
        //         confirmButtonText: "确定",
        //         type: "warning"
        //     });
        // }
      );
    },
    //批量下载
    downIds() {
      let idList = this.multipleSelection
        .map((item) => {
          return item.id;
        })
        .join(",");
      let url = "/hq/classroom/exportQRzip?idListStr=" + idList;
      this.downloadFn(url);
    },
    // 默认页面数据
    initPage() {
      this.paramSearch = {
        ...this.paramSearch,
        ...this.$refs.needSift.getValue(),
        current: 1,
      };
      this.getListFn();
    },

    // 条数
    changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    saveSuccess() {
      this.getListFn();
    },
  },
  watch: {},
  filters: {},
};
</script>


<style scoped  lang="less">
/*@import "../../../assets/css/handleBtn.less";*/
/deep/.el-table {
  width: 100%;
  .el-table__body-wrapper {
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
}
</style>
